import React from 'react';
import _ from 'lodash';

import {
  useExportReportLazyQuery,
  useStoreDetailActivityQuery
} from 'generated/graphql';
import { protectedFileUtil } from 'iron-forge-react-modules';



export interface IReport {
  id: string;
  name: string;
}

export interface IData {
  reports: IReport[];
  isSuperAdmin: boolean;
}

export function useQuery() {
  const tuple = useStoreDetailActivityQuery({});

  return React.useMemo(
    () => {
      const permissions = _.map(tuple.data?.loggedInUser?.permissions, (permission): string => permission.name);
      const data: IData = {
        reports: _.map(tuple.data?.databaseReports, (report): IReport => ({
          id: report.id,
          name: report.name
        })),
        isSuperAdmin: (tuple.data?.loggedInUser?.isSuperAdmin || _.includes(permissions, 'platform_godMode')) ?? false
      };

      return {
        ...tuple,
        data
      };
    },
    [tuple]
  );
}



export function useExportInventoryReportQuery(storeId: string) {
  const [fnQuery, tuple] = useExportReportLazyQuery({});



  const fnWrappedQuery = React.useCallback(
    async (reportId: string) => {
      const query = await fnQuery({
        variables: {
          reportId,
          storeId
        }
      });

      if (query.data?.exportReport) {
        protectedFileUtil.forceDownloadEncodedFile(query.data.exportReport);
      }
    },
    [
      fnQuery,
      storeId
    ]
  );



  const wrappedTuple = React.useMemo(
    () => {

      return {
        ...tuple
      };
    },
    [tuple]
  );

  return [
    fnWrappedQuery,
    wrappedTuple
  ] as const;
}
